import React, { useEffect, useState } from 'react';
import MainLayout from '../MainLayout';
import ListCampaignComponent from '../../components/ListCampaign';
import Loading from '../../components/Loading';
import MessengerButton from './../Home/items/MessengerButton';
import { useSelector } from 'react-redux';
import {
  getIsGuideByKey,
  GUIDE_TYPE_ENUM,
  setIsGuideByKey,
} from '../../utils/helper';
import { selectGuideListByKey } from '../../stores/config/config.selector';
import { useTranslation } from 'react-i18next';
import Tour from 'reactour';
import { Button } from '@material-ui/core';
import styles from './CampaignView.module.scss';
import cn from 'classnames';
import types from '../../constants/types';

const CampaignView = (props) => {
  const { getCampaign, campaign, loading } = props;
  const { t } = useTranslation();

  const tourOverview = useSelector(
    selectGuideListByKey(GUIDE_TYPE_ENUM.campaign_manager)
  );
  const [tourConfig, setTourConfig] = useState(null);

  useEffect(() => {
    if (getIsGuideByKey(GUIDE_TYPE_ENUM.campaign_manager) && tourOverview?.length) {
      console.log('[CampaignView] tour campaign_manager steps RAW:', JSON.stringify(tourOverview))
      // Override selector + content để khớp với UI hiện tại
      const stepOverrides = {
        // Step 1: Search
        '#select-fanpage':        { selector: '#search_campaign',       content: t('campaign_page.tour_search') },
        '#search_campaign':       { selector: '#search_campaign',       content: t('campaign_page.tour_search') },
        '#search-campaign':       { selector: '#search_campaign',       content: t('campaign_page.tour_search') },
        // Step 2: Sort dropdown
        '#sort_campaign':         { selector: '#sort_campaign',         content: t('campaign_page.tour_sort') },
        '#sort-campaign':         { selector: '#sort_campaign',         content: t('campaign_page.tour_sort') },
        '#select-sort':           { selector: '#sort_campaign',         content: t('campaign_page.tour_sort') },
        // Step 3: Filter chips
        '#filter_campaign':       { selector: '#filter_campaign',       content: t('campaign_page.tour_filter') },
        '#filter-campaign':       { selector: '#filter_campaign',       content: t('campaign_page.tour_filter') },
        '#campaign_filter':       { selector: '#filter_campaign',       content: t('campaign_page.tour_filter') },
        '#status_filter':         { selector: '#filter_campaign',       content: t('campaign_page.tour_filter') },
        '#select-status':         { selector: '#filter_campaign',       content: t('campaign_page.tour_filter') },
        // Create button (nếu có step 4 hoặc backend map nhầm)
        '#create_campaign_btn':   { selector: '#create_campaign_btn',   content: t('campaign_page.tour_create') },
        '#create-campaign':       { selector: '#create_campaign_btn',   content: t('campaign_page.tour_create') },
        '#create_campaign':       { selector: '#create_campaign_btn',   content: t('campaign_page.tour_create') },
        '#btn-create-campaign':   { selector: '#create_campaign_btn',   content: t('campaign_page.tour_create') },
      }
      const mappedSteps = tourOverview.map((step) => {
        const override = stepOverrides[step.selector]
        if (override) {
          console.log(`[CampaignView] Override step: ${step.selector} → ${override.selector}`, override)
          return { ...step, ...override }
        }
        console.log(`[CampaignView] Keep original step:`, step.selector)
        return step
      })
      console.log('[CampaignView] tour campaign_manager steps MAPPED:', JSON.stringify(mappedSteps))
      setTourConfig(mappedSteps);
      setIsGuideByKey(GUIDE_TYPE_ENUM.campaign_manager);
    }
  }, [tourOverview]);

  // KPI lấy statistic lần load đầu; không ghi đè khi filter (response không có statistic)
  const [kpiData, setKpiData] = useState({ total: 0, running: 0, waiting: 0, failed: 0 });

  useEffect(() => {
    const stats = campaign?.statistic;
    if (!stats) return;
    setKpiData({
      total: stats.totalCampaigns ?? campaign?.totalElements ?? 0,
      running: stats.runningCampaigns ?? 0,
      waiting: stats.scheduledCampaigns ?? 0,
      failed: stats.cancelCampaigns ?? 0,
    });
  }, [campaign]);

  const handleCreateCampaign = () => {
    window.open(
      `${types.URL.FACEBOOK}&token=${localStorage.getItem('token') || null}`,
      '_blank'
    );
  };

  return (
    <MainLayout>
      <Tour
        steps={tourConfig}
        isOpen={tourConfig != null}
        closeWithMask={false}
        lastStepNextButton={
          <Button size="small" className="btn--rounder" variant="contained">
            {t('common.btn.close')}
          </Button>
        }
        accentColor="#05ae34"
        onRequestClose={() => setTourConfig(null)}
      />

      {loading && <Loading />}

      <div className={styles.pageWrap}>
        {/* PAGE HEAD */}
        <div className={styles.pageHead}>
          <div>
            <div className={styles.pageTitle}>{t('campaign_view.title')}</div>
            <div className={styles.pageSub}>{t('campaign_view.sub')}</div>
          </div>
          <button id="create_campaign_btn" className={styles.btnCreateCampaign} onClick={handleCreateCampaign}>
            <svg viewBox="0 0 14 14" fill="none">
              <path d="M7 2v10M2 7h10" />
            </svg>
            {t('common.btn.create_campaign')}
          </button>
        </div>

        {/* KPI ROW */}
        <div className={styles.kpiRow}>
          {/* Total */}
          <div className={cn(styles.kpiCard)}>
            <div className={styles.kpiTop}>
              <div className={cn(styles.kpiIcon, styles.iTotal)}>
                <svg viewBox="0 0 16 16" fill="none" strokeWidth="2" stroke="currentColor">
                  <circle cx="8" cy="8" r="6" /><path d="M8 5v3l2 1.5" />
                </svg>
              </div>
              <span className={styles.kpiHint}>{t('fanpage_page.filter_all')}</span>
            </div>
            <div className={styles.kpiVal}>{kpiData.total}</div>
            <div className={styles.kpiLbl}>{t('campaign_view.kpi_total')}</div>
          </div>

          {/* Running */}
          <div className={cn(styles.kpiCard)}>
            <div className={styles.kpiTop}>
              <div className={cn(styles.kpiIcon, styles.iRun)}>
                <svg viewBox="0 0 16 16" fill="none" strokeWidth="2" stroke="currentColor">
                  <path d="M2 8l12-6-4 12-3-5-5-1z" />
                </svg>
              </div>
              <span className={styles.kpiHint}>Realtime</span>
            </div>
            <div className={styles.kpiVal}>{kpiData.running}</div>
            <div className={styles.kpiLbl}>{t('campaign_page.status_sending')}</div>
          </div>

          {/* Waiting */}
          <div className={cn(styles.kpiCard)}>
            <div className={styles.kpiTop}>
              <div className={cn(styles.kpiIcon, styles.iWait)}>
                <svg viewBox="0 0 16 16" fill="none" strokeWidth="2" stroke="currentColor">
                  <rect x="2" y="3" width="12" height="11" rx="1.5" />
                  <path d="M5.5 3V1.5M10.5 3V1.5M2 7h12" />
                </svg>
              </div>
              <span className={styles.kpiHint}>{t('campaign_view.kpi_action')}</span>
            </div>
            <div className={styles.kpiVal}>{kpiData.waiting}</div>
            <div className={styles.kpiLbl}>{t('campaign_view.kpi_waiting')}</div>
          </div>

          {/* Failed */}
          <div className={cn(styles.kpiCard, styles.kpiAlert)}>
            <div className={styles.kpiTop}>
              <div className={cn(styles.kpiIcon, styles.iWarn)}>
                <svg viewBox="0 0 16 16" fill="none" strokeWidth="2" stroke="currentColor">
                  <path d="M8 1.5L1.5 13h13L8 1.5z" /><path d="M8 6.5v3M8 11.5h.01" />
                </svg>
              </div>
              <span className={styles.kpiHint}>{t('campaign_view.kpi_view_now')}</span>
            </div>
            <div className={styles.kpiVal}>{kpiData.failed}</div>
            <div className={styles.kpiLbl}>{t('campaign_view.kpi_failed')}</div>
          </div>
        </div>

        {/* MAIN CARD */}
        <div className={styles.card}>
          <ListCampaignComponent
            getCampaign={(params) => getCampaign(params)}
            data={campaign}
            isShowFilter={true}
          />
        </div>
      </div>

      <MessengerButton />
    </MainLayout>
  );
};

CampaignView.propTypes = {};
CampaignView.defaultProps = {};

export default CampaignView;
